var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRulesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.231,
    height: 35.231,
    viewBox: "0 0 35.231 35.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.837,
    y1: 0.977,
    x2: 0.333,
    y2: 0.23,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66c6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66c6f5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_72",
    x: 0,
    y: 0,
    width: 35.231,
    height: 35.231,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ccc",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    transform: "translate(-698.13 -808)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 698.13, 808)",
    filter: "url(#Ellipse_72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.616,
    cy: 11.616,
    r: 11.616,
    transform: "translate(6 3)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10.841,
    cy: 10.841,
    r: 10.841,
    transform: "translate(704.904 811.774)",
    fill: "#dfe6ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11670.967,352.164l2.142,2.141,4.492-4.492",
    transform: "translate(-10958.537 470.556)",
    fill: "none",
    stroke: "#66c6f5",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRulesLight);
export default __webpack_public_path__ + "static/media/checkRulesLight.cab839c4d508924d5187eab57188d9f8.svg";
export { ForwardRef as ReactComponent };